import React from 'react'
import ArtifactStatusBadge from './ArtifactStatusBadge'

const ICON_BY_TYPE = {
  document:     '📄',
  presentation: '📊',
  image:        '🖼️',
  other:        '📎',
}

function formatRelativeTime(iso) {
  if (!iso) return ''
  const date = new Date(iso)
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} hr ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days} day${days === 1 ? '' : 's'} ago`
  return date.toLocaleDateString()
}

function formatSize(bytes) {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export default function ArtifactCard({ artifact, onDelete }) {
  const icon = ICON_BY_TYPE[artifact.artifact_type] || ICON_BY_TYPE.other

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm flex items-start gap-4">
      <div className="text-3xl" aria-hidden="true">{icon}</div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-3">
          <a
            href={artifact.file_url || '#'}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-slate-900 hover:text-accent-600 truncate block"
            title={artifact.name}
          >
            {artifact.name}
          </a>
          <ArtifactStatusBadge status={artifact.processing_status} />
        </div>
        <div className="mt-1 text-xs text-slate-500 truncate">
          {artifact.initiative?.name || 'No initiative'}
          {artifact.user?.full_name ? ` · ${artifact.user.full_name}` : ''}
          {artifact.file_size ? ` · ${formatSize(artifact.file_size)}` : ''}
          {artifact.created_at ? ` · ${formatRelativeTime(artifact.created_at)}` : ''}
        </div>
        {onDelete && (
          <div className="mt-3">
            <button
              type="button"
              onClick={() => onDelete(artifact)}
              className="text-xs font-medium text-slate-500 hover:text-rose-600"
            >
              Delete
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
